function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-310 -130)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.224,61.778A22.622,22.622,0,0,1,58.4,70.8,23.171,23.171,0,0,1,46.078,83.119a22.622,22.622,0,0,1-9.024,1.829,23.963,23.963,0,0,1-5.854-.732v-12.5A11.1,11.1,0,0,0,34,72.876a11.525,11.525,0,0,0,3.049.427,11.341,11.341,0,0,0,4.512-.915,11.646,11.646,0,0,0,6.159-6.159,11.159,11.159,0,0,0,.915-4.512V26.9H60.224Z",
  transform: "translate(278.8 103.771)",
  fill: "#2ac2ea"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.09,78.666A29.817,29.817,0,0,1,89.7,85.8a29.329,29.329,0,0,1-7.927-1.1,29.7,29.7,0,0,1-7.134-3.049,30.914,30.914,0,0,1-6.1-4.7,29.268,29.268,0,0,1-4.7-6.1A30.488,30.488,0,0,1,60.8,63.727a29.512,29.512,0,0,1-1.1-7.988,29.085,29.085,0,0,1,1.1-7.927,30.731,30.731,0,0,1,2.988-7.134,29.268,29.268,0,0,1,4.7-6.1A30.061,30.061,0,0,1,81.712,26.9a29.329,29.329,0,0,1,7.927-1.1,29.817,29.817,0,0,1,19.39,7.134l-6.1,10.122a19.451,19.451,0,0,0-6.1-4.207,18.11,18.11,0,0,0-14.39-.061,19.024,19.024,0,0,0-5.854,3.963A18.6,18.6,0,0,0,72.627,48.6a17.683,17.683,0,0,0-1.463,7.134,17.927,17.927,0,0,0,1.463,7.2,18.719,18.719,0,0,0,9.817,9.817,17.622,17.622,0,0,0,7.134,1.463,17.135,17.135,0,0,0,4.268-.549,19.512,19.512,0,0,0,3.9-1.463V55.739h11.22V78.666Z",
  transform: "translate(267.678 104.2)",
  fill: "#f251b4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.556,74.432a22.622,22.622,0,0,0,1.829-9.024v-4.39c0-.427-.061-.793-.061-1.22a8.172,8.172,0,0,1,.061-1.22V36.2a30.611,30.611,0,0,0-2.8,2.439,29.269,29.269,0,0,0-4.7,6.1A30.732,30.732,0,0,0,60.9,51.871,29.085,29.085,0,0,0,59.8,59.8h0a29.512,29.512,0,0,0,1.1,7.927,30.488,30.488,0,0,0,2.988,7.2,29.207,29.207,0,0,0,2.988,4.207A23.963,23.963,0,0,0,69.556,74.432Z",
  transform: "translate(267.639 100.141)",
  fill: "#714df4"
}));
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.768,
    height: 60,
    viewBox: "0 0 66.768 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.f9a1d13b29fc1627c2d07d18b347de5d.svg";
export { ForwardRef as ReactComponent };